export default __webpack_public_path__ + "static/media/vitarmonyl.bd4c22b7.png";